export default {"src":"/_next/static/media/attendance-monitoring.ebeceb60.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};